import FeedItemEditor from '@app/components/FeedItemEditor'
import ItemLeadsList from '@app/components/ItemLeadsList'
import SearchBar from '@app/components/SearchBar'
import { FeedItemSourceType, FeedItemType } from '@app/models/enums'
import { bindFunctions } from '@app/utils/class'
import * as React from 'react'
import DocumentTitle from 'react-document-title'
import { ListingPageProps } from './ListingPage'

interface IPropertyLeadsState {
  filterText: string
}

export default class PropertyLeads extends React.PureComponent<
  ListingPageProps,
  IPropertyLeadsState
> {
  constructor(props: ListingPageProps) {
    super(props)

    this.state = {
      filterText: '',
    }

    bindFunctions(this)
  }

  public render() {
    return (
      <DocumentTitle title={`${this.props.listing.title} :: Leads`}>
        <div className='mb-3'>
          <FeedItemEditor
            contextId={this.props.listing.property.id}
            contextType={FeedItemSourceType.Property}
            itemType={FeedItemType.Lead}
          />
          <SearchBar
            className='mt-3'
            value={this.state.filterText}
            onChange={this._setFilterText}
            placeholder='Filter leads...'
            size='sm'
          />
          {this._renderLeads()}
        </div>
      </DocumentTitle>
    )
  }

  private _renderLeads() {
    const leads = !this.state.filterText
      ? this.props.listing.property.leads
      : this.props.listing.property.leads
          .filter((l) => {
            return (
              l !== undefined &&
              ((l.title !== undefined &&
                l.title
                  .toLowerCase()
                  .indexOf(this.state.filterText.toLowerCase()) > -1) ||
                l.markup
                  .toLowerCase()
                  .indexOf(this.state.filterText.toLowerCase()) > -1)
            )
          })
          .toList()

    return (
      <ItemLeadsList
        className='mt-3'
        leads={leads}
        onArchive={(id) => this.props.archiveLead(id)}
        onClick={(id) => this.props.history.push(`/feed/${id}`)}
      />
    )
  }

  private _setFilterText(newFilterText: string) {
    this.setState({ filterText: newFilterText })
  }
}
